import React from 'react';
import { Mail, Phone, MapPin, MessageCircle, Instagram, Facebook } from 'lucide-react';

const Contact = () => {
    const handleWhatsAppChat = () => {
        const phoneNumber = "212624784965";
        const message = "Hello GlobalBites! I have a question about your menu.";
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    return (
        <section className="contact-section" id="contact">
            <div className="contact-info">
                <h2>Join Us For <br /> <span style={{ color: 'var(--primary)' }}>Dinner tonight</span></h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginBottom: '4rem' }}>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '1.1rem' }}>
                        <div style={{ background: 'var(--glass)', padding: '12px', borderRadius: '12px' }}><MapPin color="var(--primary)" /></div>
                        123 Culinary Way, Food District
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '1.1rem' }}>
                        <div style={{ background: 'var(--glass)', padding: '12px', borderRadius: '12px' }}><Phone color="var(--primary)" /></div>
                        +212 6 24 78 49 65
                    </div>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '1.1rem' }}>
                        <div style={{ background: 'var(--glass)', padding: '12px', borderRadius: '12px' }}><Mail color="var(--primary)" /></div>
                        bookings@globalbites.com
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '3rem' }}>
                    <a href="#" style={{ background: 'var(--glass)', padding: '15px', borderRadius: '50%', border: '1px solid var(--glass-border)', transition: 'var(--transition)' }} onMouseOver={(e) => e.currentTarget.style.borderColor = 'var(--primary)'} onMouseOut={(e) => e.currentTarget.style.borderColor = 'var(--glass-border)'}>
                        <Instagram color="var(--primary)" size={24} />
                    </a>
                    <a href="#" style={{ background: 'var(--glass)', padding: '15px', borderRadius: '50%', border: '1px solid var(--glass-border)', transition: 'var(--transition)' }} onMouseOver={(e) => e.currentTarget.style.borderColor = 'var(--primary)'} onMouseOut={(e) => e.currentTarget.style.borderColor = 'var(--glass-border)'}>
                        <Facebook color="var(--primary)" size={24} />
                    </a>
                </div>
            </div>

            <form className="contact-form" onSubmit={(e) => {
                e.preventDefault();
                alert("Shokran! Our team will contact you soon.");
            }}>
                <input type="text" placeholder="Full Name" className="input-field" required />
                <input type="email" placeholder="Email Address" className="input-field" required />
                <textarea placeholder="Your Message" className="input-field" rows="5" required></textarea>
                <button type="submit" className="submit-btn" style={{ cursor: 'pointer' }}>Send Message</button>
            </form>

            <div
                className="whatsapp-float"
                onClick={handleWhatsAppChat}
                title="Chat with us on WhatsApp"
            >
                <MessageCircle color="white" size={35} />
            </div>
        </section>
    );
};

export default Contact;
